import  { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import LogoImg from "../utils/Images/Logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "./Button";
import {
  FavoriteBorder,
  MenuRounded,
  SearchRounded,
  ShoppingCartOutlined,
  CloseRounded,
} from "@mui/icons-material";
import { Avatar, CircularProgress } from "@mui/material";
import { logout } from "../redux/reducers/userSlice";
import { useDispatch } from "react-redux";
import { getAllProducts } from "../api";

const Nav = styled.div`
  background-color: ${({ theme }) => theme.bg};
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
  color: white;
`;
const NavbarContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  padding: 0 24px;
  display: flex;
  gap: 14px;
  align-items: center;
  justify-content: space-between;
  font-size: 1rem;
`;
const NavLogo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 6px;
  font-weight: 500;
  font-size: 18px;
  text-decoration: none;
  color: inherit;
`;
const Logo = styled.img`
  height: 34px;
`;
const NavItems = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 0 6px;
  list-style: none;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
const Navlink = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  &.active {
    color: ${({ theme }) => theme.primary};
    border-bottom: 1.8px solid ${({ theme }) => theme.primary};
  }
`;
const ButtonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 28px;
  align-items: center;
  padding: 0 6px;
  color: ${({ theme }) => theme.primary};
  @media screen and (max-width: 768px) {
    display: none;
  }
`;
const MobileIcon = styled.div`
  color: ${({ theme }) => theme.text_primary};
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;
const Mobileicons = styled.div`
  color: ${({ theme }) => theme.text_primary};
  display: none;
  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }
`;
const MobileMenu = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
  padding: 0 6px;
  list-style: none;
  width: 80%;
  padding: 12px 40px 24px 40px;
  background: ${({ theme }) => theme.card_light + 99};
  position: absolute;
  top: 80px;
  right: 0;
  transition: all 0.6s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? "translateY(0)" : "translateY(-100%)")};
  border-radius: 0 0 20px 20px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  opacity: ${({ isOpen }) => (isOpen ? "100%" : "0")};
  z-index: ${({ isOpen }) => (isOpen ? "1000" : "-1000")};
`;
const TextButton = styled.div`
  text-align: end;
  color: ${({ theme }) => theme.secondary};
  cursor: pointer;
  font-size: 16px;
  transition: all 0.3s ease;
  font-weight: 600;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;
const IconButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

// ── Search overlay ──
const SearchOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.3);
  z-index: 200;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const SearchBox = styled.div`
  width: 100%;
  background: ${({ theme }) => theme.bg};
  padding: 20px 40px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  @media (max-width: 768px) {
    padding: 16px 16px;
  }
`;
const SearchInput = styled.input`
  flex: 1;
  font-size: 18px;
  border: none;
  outline: none;
  background: transparent;
  color: ${({ theme }) => theme.text_primary};
  &::placeholder {
    color: ${({ theme }) => theme.text_secondary};
  }
`;
const SearchResults = styled.div`
  width: 100%;
  max-width: 700px;
  background: ${({ theme }) => theme.bg};
  border-radius: 0 0 12px 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  max-height: 420px;
  overflow-y: auto;
  margin-top: 0;
`;
const ResultItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 20px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.text_secondary + 20};
  transition: background 0.15s;
  &:hover {
    background: ${({ theme }) => theme.text_secondary + 15};
  }
  &:last-child {
    border-bottom: none;
  }
`;
const ResultImg = styled.img`
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 6px;
`;
const ResultInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;
const ResultTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`;
const ResultCategory = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.text_secondary};
`;
const ResultPrice = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
`;
const NoResults = styled.div`
  padding: 24px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Navbar = ({ openAuth, setOpenAuth, currentUser }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  // Focus input when search opens
  useEffect(() => {
    if (searchOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchOpen]);

  // Search as user types
  useEffect(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }
    const timer = setTimeout(async () => {
      setSearchLoading(true);
      try {
        const res = await getAllProducts(`search=${searchQuery}`);
        // Filter client-side by title or name
        const filtered = res.data?.filter(
          (p) =>
            p.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            p.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            p.category?.some((c) =>
              c.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setSearchResults(filtered || []);
      } catch {
        setSearchResults([]);
      } finally {
        setSearchLoading(false);
      }
    }, 350);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const handleResultClick = (product) => {
    setSearchOpen(false);
    setSearchQuery("");
    setSearchResults([]);
    navigate(`/shop/${product._id}`);
  };

  const closeSearch = () => {
    setSearchOpen(false);
    setSearchQuery("");
    setSearchResults([]);
  };

  // Close on Escape key
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") closeSearch();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  return (
    <>
      <Nav>
        <NavbarContainer>
          <MobileIcon onClick={() => setIsOpen(!isOpen)}>
            <MenuRounded style={{ color: "inherit" }} />
          </MobileIcon>

          <NavLogo>
            <Logo src={LogoImg} />
          </NavLogo>

          <NavItems>
            <Navlink to="/">Home</Navlink>
            <Navlink to="/shop">Shop</Navlink>
            <Navlink to="/NewArrival">New Arrivals</Navlink>
            <Navlink to="/Contact">Contact</Navlink>
          </NavItems>

          {isOpen && (
            <MobileMenu isOpen={isOpen}>
              <Navlink to="/" onClick={() => setIsOpen(false)}>Home</Navlink>
              <Navlink to="/shop" onClick={() => setIsOpen(false)}>Shop</Navlink>
              <Navlink to="/NewArrival" onClick={() => setIsOpen(false)}>New Arrivals</Navlink>
              <Navlink to="/Contact" onClick={() => setIsOpen(false)}>Contact</Navlink>
              {currentUser ? (
                <Button text="Logout" small onClick={() => dispatch(logout())} />
              ) : (
                <div style={{ flex: "1", display: "flex", gap: "12px" }}>
                  <Button text="Sign Up" outlined small onClick={() => setOpenAuth(!openAuth)} />
                  <Button text="Sign In" small onClick={() => setOpenAuth(!openAuth)} />
                </div>
              )}
            </MobileMenu>
          )}

          <Mobileicons>
            <IconButton onClick={() => setSearchOpen(true)}>
              <SearchRounded sx={{ fontSize: "30px" }} />
            </IconButton>
            {currentUser ? (
              <>
                <Navlink to="/favorite">
                  <FavoriteBorder sx={{ color: "inherit", fontSize: "28px" }} />
                </Navlink>
                <Navlink to="/cart">
                  <ShoppingCartOutlined sx={{ color: "inherit", fontSize: "28px" }} />
                </Navlink>
                <Avatar src={currentUser?.img} sx={{ fontSize: "28px" }}>
                  {currentUser?.name[0]}
                </Avatar>
              </>
            ) : (
              <Button text="SignIn" small onClick={() => setOpenAuth(!openAuth)} />
            )}
          </Mobileicons>

          <ButtonContainer>
            <IconButton onClick={() => setSearchOpen(true)}>
              <SearchRounded sx={{ fontSize: "30px" }} />
            </IconButton>
            {currentUser ? (
              <>
                <Navlink to="/favorite">
                  <FavoriteBorder sx={{ color: "inherit", fontSize: "28px" }} />
                </Navlink>
                <Navlink to="/cart">
                  <ShoppingCartOutlined sx={{ color: "inherit", fontSize: "28px" }} />
                </Navlink>
                <Avatar src={currentUser?.img} sx={{ fontSize: "28px" }}>
                  {currentUser?.name[0]}
                </Avatar>
                <TextButton onClick={() => dispatch(logout())}>Logout</TextButton>
              </>
            ) : (
              <Button text="SignIn" small onClick={() => setOpenAuth(!openAuth)} />
            )}
          </ButtonContainer>
        </NavbarContainer>
      </Nav>

      {/* Search Overlay */}
      {searchOpen && (
        <SearchOverlay onClick={closeSearch}>
          <SearchBox onClick={(e) => e.stopPropagation()}>
            <SearchRounded sx={{ fontSize: "26px", color: "gray" }} />
            <SearchInput
              ref={inputRef}
              placeholder="Search for products, categories..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchLoading && <CircularProgress size={20} />}
            <IconButton onClick={closeSearch}>
              <CloseRounded sx={{ fontSize: "26px" }} />
            </IconButton>
          </SearchBox>

          {searchQuery.trim() && (
            <SearchResults onClick={(e) => e.stopPropagation()}>
              {searchResults.length === 0 && !searchLoading ? (
                <NoResults>No products found for "{searchQuery}"</NoResults>
              ) : (
                searchResults.map((product) => (
                  <ResultItem
                    key={product._id}
                    onClick={() => handleResultClick(product)}
                  >
                    <ResultImg src={product.img} alt={product.title} />
                    <ResultInfo>
                      <ResultTitle>{product.title}</ResultTitle>
                      <ResultCategory>{product.category?.join(", ")}</ResultCategory>
                    </ResultInfo>
                    <ResultPrice>${product.price?.org}</ResultPrice>
                  </ResultItem>
                ))
              )}
            </SearchResults>
          )}
        </SearchOverlay>
      )}
    </>
  );
};

export default Navbar;